<template>
  <div class="customer-tab">
    <table
      v-if="customer.participations.length"
      class="table is-bordered is-striped is-marginless is-fullwidth"
    >
      <thead>
        <tr>
          <th>Τίτλος</th>
          <th class="hidden-print">Ενέργειες</th>
        </tr>
      </thead>
      <tbody>
        <item
          v-for="(item, index) in customer.participations"
          :item="item"
          :index="index"
          :key="item.id"
        />
      </tbody>
    </table>
    <h5 v-else class="title is-5 has-text-centered is-marginless">
      Δε βρέθηκαν συμμετοχές σε διαγωνισμούς
    </h5>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Item from './components/Contest';

export default {
  components: {
    Item,
  },
  computed: {
    ...mapGetters({
      customer: 'customers/edit/getCustomer',
    }),
  },
};
</script>
